import { h, Host } from "@stencil/core";
export class NotificationItem {
    constructor() {
        this.headline = "";
        this.createdAt = "";
        this.willDeleteIn = "";
        this.willDeleteInTooltip = "";
        this.timeFormat = "HH:mm";
        this.dateFormat = "DD.MM.YYYY";
        this.type = "Detail";
        this.status = "Current";
        this.severity = "Information";
        this.source = "";
        this.sourceLink = "";
        this.closedByName = "";
        this.closedByLabel = "Closed by";
        this.closeButtonText = "Close";
        this.link = "";
        this.linkText = "";
        this.notificationUpdateEndpoint = "";
        this.notificationUpdateErrorText = "Update failed. Please try again.";
        this.notificationUpdateError = false;
    }
    baseClass = "ux-notification-item";
    /** Navigation level change event */
    updateNotificationItem;
    /** Close notification */
    closeNotification = async () => {
        this.notificationUpdateError = false;
        const response = await fetch(this.notificationUpdateEndpoint);
        response
            .json()
            .then(() => {
            this.notificationUpdateError = false;
            this.updateNotificationItem.emit({ success: true });
        })
            .catch(() => {
            this.notificationUpdateError = true;
            this.updateNotificationItem.emit({ success: false });
        });
    };
    render() {
        const { baseClass, headline, createdAt, willDeleteIn, willDeleteInTooltip, timeFormat, dateFormat, type, status, severity, source, sourceLink, closedByName, closedByLabel, closeButtonText, link, linkText, notificationUpdateError, notificationUpdateErrorText } = this;
        const utc = Number(createdAt) > 0 ? new Date(Number(createdAt) * 1000).toISOString() : "";
        return (h(Host, { key: '575ea55536649b7593b349c252b98c790a61b7cc', class: `${baseClass} ${baseClass}--${type.toLowerCase()} ${baseClass}--${severity.toLowerCase()}` }, h("div", { key: 'c04b4c2ca68cf754834fa0d42cc8cb46aaa8b089', class: `${baseClass}__icon-wrapper` }, h("ux-icon", { key: '2186d75433accd554cd875282fca651cad3181fe', name: `notification-${severity.toLowerCase()}`, weight: "bold", filled: true }), h("div", { key: 'ee995801a26071d30d23d4c9a7e590fe51b01a70', class: `${baseClass}__source-date` }, sourceLink && type.toLowerCase() === "detail" ? (h("a", { href: link, target: "_self", class: "ux-text-link ux-text-link--bold ux-text-link--green" }, source, h("ux-icon", { name: "arrow-right", weight: "normal" }))) : (h("span", { class: `${baseClass}__source ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase` }, source)), !!utc && (h("span", { key: '514a92487266b6e9773e90ae5041e0a08b13ce4d', class: `${baseClass}__date-time ux-text-tiny` }, h("span", { key: 'bb3db938958c24e9cb9d83a38ee47744641d2cf8', class: `${baseClass}__time` }, h("ux-date-time", { key: '70eb042ef50eb3025dbe8a48eb3ec7d638916ce5', utc: utc, format: timeFormat })), h("span", { key: '38d8cfcdd68d0dcbd3f052b2a8c19000a84a7046', class: `${baseClass}__date` }, h("ux-date-time", { key: '46deb9f7dccb7ca3835a0a0ea15c46b4ac7c3ca5', utc: utc, format: dateFormat })), willDeleteIn && (h("div", { key: 'f440d0ec1c21cb405a66f6d2f74c0cde524d7207', class: `${baseClass}__will-delete-in` }, willDeleteInTooltip && (h("ux-tooltip", { key: 'f1b9ab5658bd93e805b5413a7ae36dbb2f4af9f8', "tooltip-target": "ux-icon[name='clock']", align: "left" }, willDeleteInTooltip)), h("ux-icon", { key: 'b0ed39689451ab82e262794370ac74eeb635b7d8', name: "clock", weight: "bold", "size-s": "13", color: "gray" }), " ", willDeleteIn)))))), h("ux-notification-text", { key: 'e2c3c99975219267991e71d3ff6e65e4085270ea', subject: headline, link: link, linkText: linkText, notificationUpdateError: notificationUpdateError, notificationUpdateErrorText: notificationUpdateErrorText, type: type }, h("slot", { key: 'b6b8f0be9dc90776763992738ef6bd340e46511f', name: "message" })), h("div", { key: '7829bcd4d25199c46e2fd52c9d3556e683af4953', class: `${baseClass}__status-wrapper` }, status.toLowerCase() === "current" && this.notificationUpdateEndpoint !== "" && (h("ux-popover-menu", { key: '2714175e7748b0ee8e2d8c014f621a23b0ebfb3f', placement: "bottom-end" }, h("ul", { key: '4d4f05015f5be475de7588c90beaf5043f05116e' }, h("li", { key: 'fbebadd91939f364c0519d077b161322d39b7cb1', onClick: () => this.closeNotification() }, closeButtonText)))), status.toLowerCase() === "historic" && closedByName && (h("div", { key: 'b6e54cf73b929b11f894a61899c77aa08ea28db5' }, h("div", { key: '4dfa94a0f1130098ac04ec3790710bf62946e9c8', class: "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase" }, closedByLabel, ":"), h("div", { key: '09b3480a707604f52773ed1d2800f4aea41b6dc2' }, closedByName))))));
    }
    static get is() { return "ux-notification-item"; }
    static get originalStyleUrls() {
        return {
            "$": ["notification-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["notification-item.css"]
        };
    }
    static get properties() {
        return {
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The headline of this notification"
                },
                "attribute": "headline",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "createdAt": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "seconds timestamp of UTC time when this notification was created."
                },
                "attribute": "created-at",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "willDeleteIn": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text indicating when the notification will be deleted (e.g. 1h, 3d, etc.)."
                },
                "attribute": "will-delete-in",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "willDeleteInTooltip": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text elaborating on the notification deletion."
                },
                "attribute": "will-delete-in-tooltip",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "timeFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Time format string according to https://day.js.org/docs/en/display/format"
                },
                "attribute": "time-format",
                "reflect": false,
                "defaultValue": "\"HH:mm\""
            },
            "dateFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Date format string according to https://day.js.org/docs/en/display/format"
                },
                "attribute": "date-format",
                "reflect": false,
                "defaultValue": "\"DD.MM.YYYY\""
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationType",
                    "resolved": "\"Detail\" | \"Overview\"",
                    "references": {
                        "TrumpfNotificationType": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Type of notification. Can be 'Overview' or 'Detail'."
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "\"Detail\""
            },
            "status": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationStatus",
                    "resolved": "\"Current\" | \"Historic\"",
                    "references": {
                        "TrumpfNotificationStatus": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Current status of this notification, can be 'Current' or 'Historic'."
                },
                "attribute": "status",
                "reflect": false,
                "defaultValue": "\"Current\""
            },
            "severity": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationSeverity",
                    "resolved": "\"Error\" | \"Information\" | \"Warning\"",
                    "references": {
                        "TrumpfNotificationSeverity": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationSeverity"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Severity of this notification. Can be 'Information', 'Warning' or 'Error'."
                },
                "attribute": "severity",
                "reflect": false,
                "defaultValue": "\"Information\""
            },
            "source": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationSource[\"source\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationSource": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationSource"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates where this notification was sourced from, e.g. TRUMPF Service"
                },
                "attribute": "source",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "sourceLink": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationSource[\"sourceLink\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationSource": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationSource"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Source can also be a link, e.g. links to TRUMPF Service"
                },
                "attribute": "source-link",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "closedByName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationClosedBy[\"userName\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationClosedBy": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationClosedBy"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "User name of the user that changed the status of this notification to 'Historic'.\nEmpty if the status of this notification is 'Current'."
                },
                "attribute": "closed-by-name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "closedByLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationClosedBy[\"label\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationClosedBy": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationClosedBy"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label text for completety by"
                },
                "attribute": "closed-by-label",
                "reflect": false,
                "defaultValue": "\"Closed by\""
            },
            "closeButtonText": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationClosedBy[\"closeButtonText\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationClosedBy": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationClosedBy"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Close button text that leads to completion of notification"
                },
                "attribute": "close-button-text",
                "reflect": false,
                "defaultValue": "\"Close\""
            },
            "link": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationActionLink[\"link\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationActionLink": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationActionLink"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Link of the notification, e.g. link for read more button"
                },
                "attribute": "link",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "linkText": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TrumpfNotificationActionLink[\"linkText\"]",
                    "resolved": "string",
                    "references": {
                        "TrumpfNotificationActionLink": {
                            "location": "local",
                            "path": "/tmp/builds/5MRsrR2d8/4/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/packages/ux-ui/src/components/notification-item/notification-item.tsx",
                            "id": "src/components/notification-item/notification-item.tsx::TrumpfNotificationActionLink"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Link text of the notification, e.g. read more"
                },
                "attribute": "link-text",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "notificationUpdateEndpoint": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Update notification url"
                },
                "attribute": "notification-update-endpoint",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "notificationUpdateErrorText": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Update notification error text"
                },
                "attribute": "notification-update-error-text",
                "reflect": false,
                "defaultValue": "\"Update failed. Please try again.\""
            }
        };
    }
    static get states() {
        return {
            "notificationUpdateError": {}
        };
    }
    static get events() {
        return [{
                "method": "updateNotificationItem",
                "name": "uxUpdateNotificationItem",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Navigation level change event"
                },
                "complexType": {
                    "original": "{ success: boolean }",
                    "resolved": "{ success: boolean; }",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=notification-item.js.map
